import React from 'react';
import NavCountdown from 'components/NavCountdown';
import v from 'vudu';
import { styles as s, breakpoints, colors } from 'stylesheet';
import Logos from 'components/svgs/Logos';
import FrameLogotype from 'components/svgs/FrameLogotype';
import FrameSolidLockup from 'components/svgs/FrameSolidLockup';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

const localClasses = v({
  nav: {
    top: 0,
    position: 'absolute',
    width: '100%',
    height: '80px',
    display: 'flex'
  },
  hiddenOnMobile: {
    display: 'none',
    [breakpoints.md]: {
      display: 'flex'
    }
  },
  navInner: {
    '@composes': [s.flex, s.relative, s.z1, s.t0],
    width: '100%',
    paddingLeft: '20px',
    paddingRight: '20px',
    maxWidth: '1040px',
    margin: 'auto'
  },
  navHalf: {
    'aside': { display: 'none' },
    'section': {
      '@composes': [s.pl2],
      textAlign: 'left'
    }
  },
  navInitial: {
    'section': {
      display: 'none',
    }
  },
  logosImageWrapper: {
    '@composes': [s.pl2],
    width: '35%',
    textAlign: 'left',
    'img': {
      width: '100%',
      maxWidth: '140px'
    },
    'svg': { maxWidth: '100%' },
    [breakpoints.lg]: {
      textAlign: 'center',
      paddingLeft: 0
    }
  },
  navCountdownWrapper: {
    flexGrow: 1,
    flexBasis: 0,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  frameLogoWrapper: {
    '@composes': [
      s.col4,
      s.pl2,
    ],
    flexGrow: 1,
    flexBasis: 0,
    [breakpoints.lg]: {
      display: 'flex',
      alignItems: 'center'
    }
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    'svg:first-of-type': {
      marginRight: '1rem',
    }
  }
});

export default withRouter((props) => {
  let variant, split, hiddenOnMobile;
  switch(props.location.pathname) {
    case '/':
      split = 'initial';
      variant = 'white';
      hiddenOnMobile = false;
      break;
    case '/bonus':
      split = 'half';
      variant = 'neonBlue';
      hiddenOnMobile = true;
      break;
    case '/terms':
      split = 'half';
      variant = 'byzantine';
      hiddenOnMobile = false;
      break;
    case '/questionnaire':
    case '/qualify':
    default:
      hiddenOnMobile = true;
      split = 'half';
      variant = 'byzantine';
      break;
  }
  let navInnerClasses = localClasses.navInner;
  if (split === 'half') navInnerClasses += ` ${localClasses.navHalf}`;
  if (split === 'initial') {
    navInnerClasses += ` ${localClasses.navInitial}`;
  }

  let classes = localClasses.nav;
  if (hiddenOnMobile) classes += ` ${localClasses.hiddenOnMobile}`;
  return (
    <div className={classes}>
      <header className={navInnerClasses}>
        <aside className={localClasses.frameLogoWrapper}>
          <Link to="/" className={localClasses.logoLink}>
            <FrameSolidLockup fill={colors[variant]} />
          </Link>
        </aside>
        <section className={localClasses.logosImageWrapper}>
          <Link to="/">
            <FrameSolidLockup fill={colors[variant]} />
          </Link>
        </section>
        <div className={localClasses.navCountdownWrapper}>
          <NavCountdown color={variant} />
        </div>
      </header>
    </div>
  )
});



// WEBPACK FOOTER //
// ./src/components/Nav.js